import api from './api';

export type OrderPlanType = 'material' | 'service';

export interface OrderPlanItem {
  id: number;
  project_id: string;
  sequence_number: number;
  type: OrderPlanType;
  description: string;
  lead_time_days: number;
  deadline_date: string | null;
  delivery_date: string | null;
  status: 'zbieranie ofert' | 'rozbieżności projektowe' | 'negocjacje' | 'zamówiono';
  order_date: string | null;
  remaining_days?: number | null; // virtual
  created_at?: string;
  updated_at?: string;
}

export interface CreateOrderPlanItemPayload {
  project_id: string;
  type: OrderPlanType;
  description: string;
  lead_time_days?: number;
  deadline_date?: string | null;
  status?: OrderPlanItem['status'];
  order_date?: string | null;
}

const orderPlanService = {
  async list(projectId: string): Promise<OrderPlanItem[]> {
    const res = await api.get(`/order-plan/project/${projectId}`);
    return res.data;
  },
  async create(payload: CreateOrderPlanItemPayload): Promise<OrderPlanItem> {
    const res = await api.post('/order-plan', payload);
    return res.data;
  },
  async update(id: number, payload: Partial<CreateOrderPlanItemPayload>): Promise<OrderPlanItem> {
    const res = await api.put(`/order-plan/${id}`, payload);
    return res.data;
  },
  async remove(id: number): Promise<void> {
    await api.delete(`/order-plan/${id}`);
  }
};

export default orderPlanService;


